import React, { useState, useEffect, useContext } from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';
import { EditorProps, EditorOption } from '../Model/EditorModel';
import { TriggerDispatchContext } from '../Model/TriggerState';
import { Paper } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { PermissionsContext } from '../../UIContainer/PermissionsWrapper';
import PermissionConstants from '../../../Common/Constants/PermissionConstants';
import { PreferredThemeContext } from '../../../../Theme/UseToggleDarkMode';
import { extractTriggerName } from '../TriggerHelper';

import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
import 'codemirror/theme/xq-light.css';
import 'codemirror/theme/neat.css';
import 'codemirror/mode/sql/sql.js';

const useStyles = makeStyles()(() => ({
  root: {
    width: '100%',
    maxWidth: '1030px',
  },
  codeMirror: {
    height: '80vh',
  },
}));

export default function TriggerEditor(props: Readonly<EditorProps>) {
  const { content, editorContentChangedCallback } = props;
  const { classes } = useStyles();

  const [editorValue, setEditorValue] = useState('');
  const [initialVaule, setInitialVaule] = useState('');

  const permissions = useContext(PermissionsContext);
  const prefersDarkMode = useContext(PreferredThemeContext);

  useEffect(() => {
    setEditorValue(content);
    setInitialVaule(content);
  }, [content]);

  const onEditorChange = () => {
    const editorContent = JSON.stringify(editorValue);
    const initialContent = JSON.stringify(initialVaule);
    const contentChanged =
      initialContent
        .toLowerCase()
        .localeCompare(editorContent.toLowerCase()) !== 0;

    editorContentChangedCallback(contentChanged);
  };

  const options: EditorOption = {
    mode: 'sql',
    theme: prefersDarkMode ? 'material' : 'xq-light',
    lineNumbers: true,
    readOnly: permissions[PermissionConstants.WriteTrigger]
      ? false
      : 'nocursor',
  };

  return (
    <Paper className={classes.root}>
      <TriggerDispatchContext.Consumer>
        {(dispatch) => (
          <CodeMirror
            className={classes.codeMirror}
            value={editorValue}
            options={options}
            editorDidMount={(editor) => {
              editor.setSize('', '80vh');
            }}
            onBeforeChange={(editor, data, value) => {
              dispatch({ type: 'content', payload: value });
              const triggerName = extractTriggerName(value);
              if (triggerName) {
                dispatch({ type: 'name', payload: triggerName });
              }
              setEditorValue(value);
            }}
            onChange={() => {
              onEditorChange();
            }}
          />
        )}
      </TriggerDispatchContext.Consumer>
    </Paper>
  );
}
